export default __webpack_public_path__ + "static/angular-2f3764e2ec8b0b47ebe68f2f80260ef1.jpg";